import dayjs, { Dayjs } from 'dayjs';

export const checkInvoiceOverdueDate = (date: Nullable<Dayjs> | string | undefined): boolean => {
  const today = dayjs().startOf('day');

  const isOverdueDate = dayjs().startOf('day').isSame(date) || dayjs(date).isBefore(today);

  return isOverdueDate;
};
